import { render, staticRenderFns } from "./CountDownAlert.vue?vue&type=template&id=3ce2d7ae&"
import script from "./CountDownAlert.vue?vue&type=script&lang=js&"
export * from "./CountDownAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports